import { Component, isDevMode, OnDestroy, OnInit } from '@angular/core';
import {environment} from "../../../../../../../environments/environment";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../../../interfaces/Centres";
import {UserData} from "../../../../../../auth.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute, Router} from "@angular/router";
import {CentreService} from "../../../../../../services/centre.service";
import firebase from "firebase/compat/app";
import {EditCenterHighlightItemComponent} from "../edit-center-highlight-item/edit-center-highlight-item.component";
import Editor from "@ckeditor/ckeditor5-build-classic";
import {LogService} from "../../../../../../services/log.service";

@Component({
  selector: 'app-add-center-highlight',
  templateUrl: './add-center-highlight.component.html',
  styleUrls: ['./add-center-highlight.component.scss']
})
export class AddCenterHighlightComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  centerHighlightForm!: FormGroup;
  editMode: boolean = false;
  mSelectedCentre: any;
  centres$!: Observable<Centre[]>;
  narrative: string = '';
  centreName: any;
  firstName: any;
  lastName: any;
  highlighTypeList$!: Observable<any[]>
  userData: UserData = JSON.parse(localStorage.getItem('userData')!) as UserData
  highlightId!: string | null;
  mHightlights: any[] = []
  displayedColumns = ['position', 'addedBy', 'narrative', 'highlight', 'createdAt', 'action']

  constructor(
              private readonly mFirestore: AngularFirestore,
              private mDatabase: AngularFireDatabase,
              private readonly mDialog: MatDialog,
              private fb: FormBuilder,
              private _snackBar: MatSnackBar,
              private mRouter: Router,
              private  logService:LogService,
              private route: ActivatedRoute,
              private readonly mCentreService: CentreService) {
    this.centres$ = this.mCentreService.getAllCentres();
    this.highlighTypeList$ = mDatabase.list<any>('types/Center Highlight').valueChanges();
  }

  ngOnInit() {
    this.initializeForm();
    this.route.paramMap.pipe(takeUntil(this._destroyed$)).subscribe(params => {
      this.highlightId = params.get('id');
      if (this.highlightId) {
        this.editMode = true;
        this.loadHighlightData(this.highlightId);
      }
    });
    if (this?.userData) {
      this.centerHighlightForm.patchValue({
        addedBy: this.userData?.userName,
        addedbyEmail: this.userData?.email,
      });
    }
  }

  private loadHighlightData(highlightId: string) {
    this.mFirestore
      .collection(this.env.centreHighlights)
      .doc(highlightId)
      .get()
      .subscribe(doc => {
        if (doc.exists) {
          const data: any = doc.data();
          if (data) {
            console.log('Hightlights', data)
            this.mHightlights = data.highlights
            const h:any[] = this.mHightlights
            // Patch top-level fields
            this.centerHighlightForm.patchValue({
              centreCode: data.centreCode,
              narrative: data.narrative,
              eventDate: data.eventDate.toDate(),
            });
            this.centerHighlightForm.setValue({
              narrative: data.narrative,
            })

            if (data.highlights && data.highlights.length > 0) {
              this.setHighLightsTable(data.highlights)
              const firstHighlight = data.highlights;

              // Patch the highlight-specific fields into the form
              this.centerHighlightForm.patchValue({
                highlight: firstHighlight.highlight,
                narrative: firstHighlight.narrative,
                createdAt: firstHighlight.createdAt,
                addedBy: firstHighlight.addedBy,
                addedbyEmail: firstHighlight.addedbyEmail,
              });
            }

          }
        }
      });
  }

  private initializeForm() {
    this.centerHighlightForm = this.fb.group({
      centreCode: ['', Validators.required],
      addedBy: ['', Validators.required],
      addedbyEmail: ['', Validators.required],
      highlight: [''],
      narrative: [''],
      eventDate: ['', Validators.required],
      createdAt: [new Date()],
    });
  }


  get getCentre() {
    return this.centerHighlightForm.value.centreCode
  }


  onSubmit() {
    if (this.centerHighlightForm.valid) {
      if (this.highlightId) {
        if (!this.highlightId) {
          console.error('No highlight ID provided for update.');
          return;
        }

        const updatedData: any = {
          centreCode: this.centerHighlightForm.value.centreCode,
          narrative: this.centerHighlightForm.value.narrative,
          eventDate: this.centerHighlightForm.value.eventDate ? new Date(this.centerHighlightForm.value.eventDate) : null,
        };

        // If there are highlights, update the first highlight
        if (this.centerHighlightForm.value.highlight) {
          updatedData.highlights = [
            {
              highlight: this.centerHighlightForm.value.highlight,
              narrative: this.centerHighlightForm.value.narrative,
              addedBy: this.centerHighlightForm.value.addedBy,
              addedbyEmail: this.centerHighlightForm.value.addedbyEmail,
              createdAt: new Date(), // Update createdAt with the current timestamp
              eventDate: this.centerHighlightForm.value.eventDate ? new Date(this.centerHighlightForm.value.eventDate) : null,
            },
          ];
        }

        // Firestore update operation
        // this.mFirestore
        //   .collection(this.env.centreHighlights)
        //   .doc(this.highlightId)
        //   .update(updatedData)
        //   .then(() => {
        //     console.log('Highlight updated successfully');
        //     this._snackBar.open('Highlight updated successfully!', 'Close', {duration: 3000});
        //     this.mRouter.navigateByUrl('home/reports/highlight-list');
        //   })
        //   .catch(error => {
        //     console.error('Error updating highlight:', error);
        //     this._snackBar.open('Failed to update highlight.', 'Close', {duration: 3000});
        //   });
        // Firestore update operation
        this.mFirestore
          .collection(this.env.centreHighlights)
          .doc(this.highlightId)
          .update(updatedData)
          .then(() => {
            console.log('Highlight updated successfully to Firestore');

            let activity = {
              date: new Date().getTime(),
              section: 'Centre Highlights',
              action: 'Edit',
              description: `Centre Hightlight edited for ${this.highlightId}  registered  by ${this.userData.userName}  `,
              currentIp: localStorage.getItem('currentip')!
            }
            this.logService.addLog(activity)
            this._snackBar.open('Highlight updated successfully!', 'Close', {duration: 3000});
            this.mRouter.navigateByUrl('home/reports/highlight-list');

            // Removed early Snackbar
          })
          .catch(error => {
            console.error('Error updating highlight:', error);
            this._snackBar.open('Failed to update highlight.', 'Close', {duration: 3000});
          });

      } else {
        const centerId: string = this.getCentre;
        this.mFirestore.collection(this.env.centreHighlights).doc(centerId)
          .set({
              centreCode: this.getCentre,
              narrative: this.centerHighlightForm.value.narrative,
              eventDate: this.centerHighlightForm.value.eventDate,
              highlights: firebase.firestore.FieldValue.arrayUnion(this.centerHighlightForm.value),
            }, {merge: true}
          ).then(() => {
              //ADD Log Here
          let activity = {
            date: new Date().getTime(),
            section: 'Centre Highlights',
            action: 'Edit',
            description: `Centre Hightlight edited for ${centerId}  registered  by ${this.userData.userName}  `,
            currentIp: localStorage.getItem('currentip')!
          }
          this.logService.addLog(activity)


          this._snackBar.open('Highlight added successfully!', 'Close', {
            duration: 3000,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            panelClass: ['success-snackbar'],
          });
          this.mRouter.navigateByUrl('home/reports/highlight-list');
        }).catch(error => {
          console.error('Error saving highlight:', error);
        });
      }
    }
  }

  cancel() {
    this.mRouter.navigateByUrl('home/reports/highlight-list');
  }

  private setHighLightsTable(highlights: any[]) {
    alert(highlights)
    this.mHightlights = highlights
    alert(this.mHightlights.length)

  }

  // editDialog(element: any, position: number) {
  //   this.mDialog.open(
  //     EditCenterHighlightItemComponent,
  //     {
  //       data: {
  //         highlight: element,
  //         position: position
  //       }
  //     }
  //   ).afterClosed().subscribe(res => {
  //       this.mHightlights[position].narrative = this.mHightlights[position].narrative.toString();
  //       this.mFirestore.collection(this.env.centreHighlights).doc(this.highlightId!!)
  //         .update({
  //           "highlights": this.mHightlights
  //         })
  //         .then(() => {
  //           this._snackBar.open('Update Successful', '', {
  //             duration: 3000,
  //             panelClass: 'snackbar-success'
  //           });
  //         })
  //         .catch((err) => {
  //           console.error(err);
  //           this._snackBar.open('Error while updating: ' + err.message, "ERROR", {
  //             duration: 3000,
  //             panelClass: 'snackbar-error'
  //           });
  //         });
  //     }
  //   )
  // }

  editDialog(element: any, position: number) {
    this.mDialog.open(EditCenterHighlightItemComponent, {
      data: {
        highlight: element,
        position: position
      }
    }).afterClosed().subscribe(res => {
      // Only proceed if dialog returns updated data
      if (res) {
        // Update the local data
        this.mHightlights[position] = res;

        this.mFirestore.collection(this.env.centreHighlights).doc(this.highlightId!!)
          .update({
            "highlights": this.mHightlights
          })
          .then(() => {
            this._snackBar.open('Update Successful', '', {
              duration: 3000,
              panelClass: 'snackbar-success'
            });
          })
          .catch((err) => {
            console.error(err);
            this._snackBar.open('Error while updating: ' + err.message, "ERROR", {
              duration: 3000,
              panelClass: 'snackbar-error'
            });
          });
      }
      // if res is undefined (user closed dialog without saving) → do nothing
    });
  }


  deleteItem(element: any, index: number) {
    if (confirm('Are you sure you want to delete this item?')) {
      this.mHightlights.splice(index, 1);
      // Update Firestore with the updated array
      this.mFirestore.collection(this.env.centreHighlights).doc(this.highlightId!!)
        .update({ highlights: this.mHightlights })
        .then(() => {
          this._snackBar.open('Deleted successfully!', '', {
            duration: 3000,
            panelClass: 'snackbar-success'
          });
        })
        .catch((error) => {
          console.error('Error deleting item: ', error);
          this._snackBar.open('Error deleting: ' + error.message, 'ERROR', {
            duration: 3000,
            panelClass: 'snackbar-error'
          });
        });
    }
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

    protected readonly Editor = Editor;
}
